var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/duplicate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66927 5.83333V12.5C6.66927 12.942 6.84487 13.366 7.15743 13.6785C7.46999 13.9911 7.89391 14.1667 8.33594 14.1667H13.3359M6.66927 5.83333V4.16667C6.66927 3.72464 6.84487 3.30072 7.15743 2.98816C7.46999 2.67559 7.89391 2.5 8.33594 2.5H12.1576C12.3786 2.50005 12.5905 2.58788 12.7468 2.74417L16.4251 6.4225C16.5814 6.57874 16.6692 6.79067 16.6693 7.01167V12.5C16.6693 12.942 16.4937 13.366 16.1811 13.6785C15.8686 13.9911 15.4446 14.1667 15.0026 14.1667H13.3359M6.66927 5.83333H5.0026C4.56058 5.83333 4.13665 6.00893 3.82409 6.32149C3.51153 6.63405 3.33594 7.05797 3.33594 7.5V15.8333C3.33594 16.2754 3.51153 16.6993 3.82409 17.0118C4.13665 17.3244 4.56058 17.5 5.0026 17.5H11.6693C12.1113 17.5 12.5352 17.3244 12.8478 17.0118C13.1603 16.6993 13.3359 16.2754 13.3359 15.8333V14.1667",
    stroke: "#79808A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDuplicate);
export default __webpack_public_path__ + "static/media/ic_duplicate.c2f6c877cc9a9605e72834ada191b974.svg";
export { ForwardRef as ReactComponent };